import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import { MODULES } from '../../constants';
import 'react-quill/dist/quill.snow.css';
import './style.scss';

const EventDescription = (props) => {
  const { 
    showHeader=true,
    setFormData, 
    formData,
    disabled,
  } = props;

  const ref = useRef(null);

  const handleChange = (value) => {
    setFormData({ ...formData, description: value });
  };

  return (
    <>
      {showHeader && <h1 className='heading-36 mb-9'>Add event description (Optional)</h1>}

      <div className='textEditor flex flex-col gap-3 flex-1 text-14 overflow-auto'>
        <div className='label-16 text-black'>Description</div>
        <ReactQuill
          id="event-description-editor"
          value={formData?.description} 
          modules={MODULES}
          ref={ref}
          onChange={handleChange}
          placeholder="Who should attend this event? Short description about your event "
          readOnly={disabled}
        />  
      </div>

    </>

  ) 
}

export default EventDescription;